import './styles.scss';

import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

export const PageError = ({ isNotFound = true }: { isNotFound?: boolean }) => {
  const navigate = useNavigate();

  return (
    <div className="page-error-container">
      <Result
        status={isNotFound ? '404' : undefined}
        title={isNotFound ? '404' : ''}
        subTitle={
          isNotFound ? 'Извините, страница не найдена' : 'Возникла непредвиденная ошибка'
        }
        extra={[
          <Button type="primary" key="home" onClick={() => navigate('/')} size="large">
            На главную
          </Button>,
          <Button key="back" onClick={() => navigate(-1)} size="large">
            Вернуться назад
          </Button>,
        ]}
      />
    </div>
  );
};
